import React, { Component } from "react";
import ReactDOM from 'react-dom';
import FloatingWindow from "./FloatingWindow";

var lastId2 = 1;

class FloatingWindowDocumento extends Component {

    frame = null;

    constructor(props) {
        super(props);
        this.state = {
            width: 0,
            height: 0,
            opacity: this.props.opacity || 0.7,
            padding: this.props.padding || 10,
            fontFamily: this.props.fontFamily || 'Caecilia'
        }

        this.id2 = `fw2_${lastId2++}`;
        this.ref2 = React.createRef();
        this.className = this.props.className;

        this.frame = FloatingWindow.jsFrame.create({
            title: this.props.title,
            left: this.props.left,
            top: this.props.top,
            width: this.props.size.width,
            height: this.props.size.height,
            //minWidth: 220, 
            //minHeight: 200,
            movable: true,//Enable to be moved by mouse
            resizable: true,//Enable to be resized by mouse
            appearanceName: 'material',//Preset name is 'yosemite','redstone','popup'
            appearanceParam: {
                border: {
                    shadow: '2px 2px 10px  rgba(0, 0, 0, 0.5)',
                    width: 0,
                    radius: 6,
                },
                titleBar: {
                    color: 'white',
                    background: '#0b7e7a',
                    leftMargin: 40,
                    height: 30,
                    fontSize: 14,
                    buttonWidth: 36,
                    buttonHeight: 16,
                    buttonColor: 'white',
                    buttons: [
                        {
                            fa: 'fas fa-times',
                            name: 'closeButton',
                            visible: true
                        },
                        {
                            fa: 'fas fa-expand-arrows-alt',
                            name: 'maximizeButton',
                            visible: true
                        },
                        {
                            fa: 'fas fa-compress-arrows-alt',
                            name: 'minimizedButton',
                            visible: false
                        },
                    ],
                    buttonsOnLeft: [
                        {
                            fa: 'fas fa-bars',
                            name: 'menu',
                            visible: true
                        },
                    ],
                },
            },
            style: {
                backgroundColor: '#fff',
                overflow: 'auto',
                width: '100%'
            },
            html: '<div id="' + this.id2 + '" ' +
                'className="' + this.className + '" ' +
                'ref2="' + this.ref2 + '" ' +
                ' style="padding:' + this.state.padding + 'px; font-size:15px; color:black;"' +
                '>' + this.props.children + '</div>'
        });

        const id = this.frame.getWindowId() + '_titleBarText'
        document.getElementById(id).style.fontFamily = this.state.fontFamily

        this.frame.setControl({
            maximizeButton: 'maximizeButton',
            demaximizeButton: 'restoreButton',
            minimizeButton: 'minimizeButton',
            deminimizeButton: 'deminimizeButton',
            hideButton: 'closeButton',
            animation: true,
            animationDuration: 150,
            maximizeWithoutTitleBar: true,
            restoreKey: 'Escape',

        });
        this.frame.control.on('hid', (frame, info) => {
            frame.closeFrame();
        });

        this.frame.control.on('maximized', (frame, info) => {
            FloatingWindow.jsFrame.showToast({
                text: 'Pressione "ESC" para minimizar.', align: 'center'
            });
        });
        this.frame.control.on('demaximized', (frame, info) => {

        });

        this.frame.on('menu', 'click', (_frame, evt, info) => {
            this.props.abrirOuFecharSumario()
        });
    }

    componentDidMount = () => {

        this.update();

        this.frame.on('closeButton', 'click', (frame, info) => {
            this.props.close()
            this.frame.hide()
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.isShow)
            this.frame.show();
        else
            this.frame.hide()


        if (this.props.size.width !== this.state.width || this.props.size.height !== this.state.height) {
            this.frame.setSize(this.props.size.width, this.props.size.height)
            this.setState({ width: this.props.size.width, height: this.props.size.height })
        }
        this.update();
    }

    componentWillUnmount = () => { }

    update = () => {
        ReactDOM.render(this.props.children, document.getElementById(this.id2));
    }

    render = () => null;

}

export default FloatingWindowDocumento;